export default __webpack_public_path__ + "static/media/my-books-gold.20e775ba.svg";